import React, { useState, Dispatch, SetStateAction } from 'react';

import { useParams } from 'react-router-dom';
import { useQuery } from 'react-query';
import Swal from 'sweetalert2';

import { ICustomerProductData, IProductData } from 'src/environments/Checkout/interfaces';
import { apiCheckout } from 'src/environments/Checkout/api';

import CreditCardForm from './components/CreditCardForm';
import ConcludePurchase from './components/ConcludePurchase';

import loadingGIF from '../../../../../../../../assets/gifs/loading.png';

type Props = {
  customerData: ICustomerProductData;
  productData: IProductData;
  setShowPaymentMethod: Dispatch<SetStateAction<string>>;
  platform: string;
};

export default function PurchasePayment({
  customerData,
  productData,
  setShowPaymentMethod,
  platform,
}: Props): JSX.Element {
  const [showCardForm, setShowCardForm] = useState(false);

  const { token } = useParams();

  const {
    isLoading: loadingCardsIds,
    isError,
    data: cardsIds,
  } = useQuery(['getCardsIds', token], async () => apiCheckout.getCardsIds(token), {
    onError: () => {
      void Swal.fire({
        icon: 'error',
        title: 'Ocorreu um erro!',
        text: 'Por favor, tente novamente mais tarde, ou contate a central.',
        iconColor: 'black',
        confirmButtonColor: 'black',
      });
    },
    onSuccess: () => {},
    refetchOnWindowFocus: false,
  });

  if (loadingCardsIds || isError) {
    return <img src={loadingGIF} alt="Loading spinning" width="100" height="100" />;
  }

  return (
    <>
      {showCardForm || cardsIds.length === 0 ? (
        <CreditCardForm
          customerData={customerData}
          setShowCardForm={setShowCardForm}
          setShowPaymentMethod={setShowPaymentMethod}
          hasCards={cardsIds.length > 0}
        />
      ) : (
        <ConcludePurchase
          customerData={customerData}
          setShowCardForm={setShowCardForm}
          cardsIds={cardsIds}
          productData={productData}
          setShowPaymentMethod={setShowPaymentMethod}
          platform={platform}
        />
      )}
    </>
  );
}
